import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabase'

export default function SetPassword() {
  const [password, setPassword] = useState('')
  const [password2, setPassword2] = useState('')
  const [loading, setLoading] = useState(false)
  const [ready, setReady] = useState(false)
  const [error, setError] = useState(null)
  const [done, setDone] = useState(false)
  const navigate = useNavigate()

  // Cuando llegamos acá, Supabase debe haber procesado el token del magic link
  // y dejarnos con una sesión válida. Verificamos.
  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => {
      if (data?.session) setReady(true)
      else setError('El link expiró o no es válido. Pedí un nuevo email de reset.')
    })
  }, [])

  async function handleSubmit(e) {
    e.preventDefault()
    setError(null)
    if (password.length < 8) { setError('La contraseña debe tener al menos 8 caracteres.'); return }
    if (password !== password2) { setError('Las contraseñas no coinciden.'); return }
    setLoading(true)
    const { error } = await supabase.auth.updateUser({ password })
    setLoading(false)
    if (error) { setError(error.message); return }
    setDone(true)
    setTimeout(() => navigate('/', { replace: true }), 2000)
  }

  return (
    <div className="login-shell">
      <div className="login-card">
        <div className="brand">Lim<em>pack</em></div>
        <div className="tag">Limpieza, resuelta cada mes.</div>

        <h1>Crear contraseña nueva</h1>

        {done ? (
          <div style={{ background: '#ECFDF5', border: '1.5px solid #10B981', borderRadius: 10, padding: 16, marginTop: 16, textAlign: 'center' }}>
            <div style={{ fontSize: 32, marginBottom: 8 }}>✅</div>
            <p style={{ margin: 0, color: '#065F46', fontWeight: 700 }}>¡Listo! Te llevamos a tu panel…</p>
          </div>
        ) : !ready ? (
          <div style={{ padding: 20, textAlign: 'center', color: 'var(--muted)' }}>
            {error ? <p style={{ color: '#991B1B' }}>{error}</p> : 'Verificando link…'}
          </div>
        ) : (
          <>
            <p className="lead">Elegí una contraseña nueva para tu cuenta.</p>
            <form onSubmit={handleSubmit}>
              <label>
                <b>Nueva contraseña</b>
                <input
                  type="password"
                  required
                  minLength={8}
                  autoComplete="new-password"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  placeholder="Mínimo 8 caracteres"
                />
              </label>
              <label>
                <b>Repetí la contraseña</b>
                <input
                  type="password"
                  required
                  minLength={8}
                  autoComplete="new-password"
                  value={password2}
                  onChange={e => setPassword2(e.target.value)}
                />
              </label>
              <button type="submit" disabled={loading}>
                {loading ? 'Guardando…' : 'Guardar contraseña'}
              </button>
              {error && <div className="err">{error}</div>}
            </form>
          </>
        )}
      </div>
    </div>
  )
}
